import '../sass/project.scss';
import './ticket_dialog';

import mediumZoom from 'medium-zoom'

window.mediumZoom = mediumZoom;
